import { fromJS } from 'immutable';
import { markAsSync } from '../../useController';
import { getInitialEditorState } from './NoteInput.helpers';
import { EDIT_NOTE_VIEW, EMPTY_NOTE_VIEW, MAX_CHARS, READ_ONLY_VIEW } from './NoteInputContext';

markAsSync(setView);
export function setView(state, view) {
  const isDisabledBtn = view === EDIT_NOTE_VIEW;
  if (this.disableSubmitBtn) this.disableSubmitBtn(isDisabledBtn);

  return state.set('view', view);
}

markAsSync(setEditorState);
export function setEditorState(state, editorState) {
  return state.set('editorState', editorState);
}

markAsSync(setIsEditing);
export function setIsEditing(state, isEditing) {
  return state.set('isEditing', isEditing);
}

markAsSync(resetNote);
export function resetNote(state) {
  const updatedView = this.note?.get('text') ? READ_ONLY_VIEW : EMPTY_NOTE_VIEW;

  if (this.disableSubmitBtn) this.disableSubmitBtn(false);
  return state
    .set('view', updatedView)
    .set('editorState', getInitialEditorState(this.note))
    .set('isEditing', false)
    .set('charLeft', MAX_CHARS);
}

markAsSync(changeText);
export function changeText(state, text, inputData) {
  const textByBlock = inputData.blocks.map(block => block.text.length);
  const sum = textByBlock.reduce((accumulator, value) => {
    return accumulator + value;
  }, 0);

  return state
    .set('inputData', inputData)
    .set('textValue', text)
    .set('charLeft', MAX_CHARS - sum);
}

markAsSync(updateCharCount);
export function updateCharCount(state, inputData) {
  const textByBlock = inputData.blocks.map(block => block.text.length);
  const sum = textByBlock.reduce((accumulator, value) => {
    return accumulator + value;
  }, 0);

  return state.set('charLeft', MAX_CHARS - sum);
}

export function getUsersToTagInNotes() {
  const { jobId, taskId } = this.info();

  return this.notesService
    .searchRelatedParties({}, { params: { jobId, taskId } })
    .then(data => fromJS(data).toArray())
    .then(users => state => state.set('usersToTag', users));
}
